import React, { useCallback, useEffect, useState } from "react";
import Pager from "../../components/Pager";
import { errorMessage } from "../../services";
import { getAuditLogs } from "../../services/admin";
import { useDebounced } from "../../utils/hooks";
import DataTable from "../../components/DataTable";
import Loader from "../../components/Loader";

// Who did what, newest first (Super Admin only)
export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [meta, setMeta] = useState({ total: 0, page: 1, pages: 1 });
  const [action, setAction] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState("");
  const [loaded, setLoaded] = useState(false);
  const debouncedAction = useDebounced(action);

  const load = useCallback(async () => {
    try {
      const { data } = await getAuditLogs({ action: debouncedAction.trim().toUpperCase().replace(/\s+/g, "_"), page: pageNumber, limit: 20 });
      setLogs(data.logs);
      setMeta({ total: data.total, page: data.page, pages: data.pages });
      setError("");
    } catch (err) {
      setError(errorMessage(err));
    }
    setLoaded(true);
  }, [debouncedAction, pageNumber]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="panel table-panel tab-gap">
      <div className="panel-heading"><div><h2>Audit log</h2><p>Sensitive actions across the platform.</p></div></div>
      <div className="table-toolbar">
        <input value={action} onChange={(e) => { setAction(e.target.value); setPageNumber(1); }} placeholder="Filter by action, e.g. STORE_DISABLE" />
        <span>{meta.total} entries</span>
      </div>
      {error && <div className="admin-error">{error}</div>}
      <DataTable>
          <thead><tr><th>WHEN</th><th>WHO</th><th>ACTION</th><th>TARGET</th></tr></thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log._id}>
                <td>{new Date(log.createdAt).toLocaleString("en-IN")}</td>
                <td><b>{log.actorName || "System"}</b><small className="cell-sub">{log.role}</small></td>
                <td>{log.action}</td>
                <td>{log.targetType} {log.targetId}</td>
              </tr>
            ))}
            {!logs.length && <tr><td colSpan="4" className="empty-row">{loaded ? "No entries." : <Loader label="Loading activity" />}</td></tr>}
          </tbody>
      </DataTable>
      <Pager page={meta.page} pages={meta.pages} total={meta.total} noun="entries" onPage={setPageNumber} />
    </div>
  );
}
